import get from "lodash/get";
import { useEffect } from "react";
import compact from "lodash/compact";
import queryString from "query-string";

import { amplitudeClient, bugsnagClient } from "@/bootstrap";
import { useMetrics } from "../app/useMetrics";

interface Props {
  userId?: string | null;
  gender?: string | null;
  preferredCurrency?: string | null;
}

const genderMap = {
  MALE: "m",
  FEMALE: "f",
};

const captureQueryStringUserProperties = (
  properties = ["affiliate_label"]
): { [key: string]: string } => {
  const { url, query } = queryString.parseUrl(window.location.toString());
  let captured: { [key: string]: string } = {};

  properties.forEach((v) => {
    let param = query[v];
    if (param && typeof param === "string") {
      captured[v] = param;
      delete query[v];
    }
  });

  window.history.replaceState(
    {},
    "",
    compact([url, queryString.stringify(query)]).join("?")
  );

  return captured;
};

const useTracking = (props: Props) => {
  const { emit } = useMetrics();
  useEffect(() => {
    const { userId } = props;
    if (!!userId) {
      amplitudeClient?.setUserId(userId);
      const userProperties = captureQueryStringUserProperties();
      amplitudeClient?.setUserProperties(userProperties);
      bugsnagClient.setUser(userId);
      emit("setUserProperties", {
        uid: userId,
        $gender: get(genderMap, props.gender || ""),
        $currency: props.preferredCurrency,
      });
    } else {
      amplitudeClient?.setUserId(null);
      bugsnagClient.setUser(undefined);
      emit("setUserProperties", {
        uid: "",
        $gender: "",
        $currency: props.preferredCurrency,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
};

export default useTracking;
